import { useEffect } from 'react';

// Only one audible <video>/<audio> element at a time within whatever subtree
// mounts this (e.g. a page that renders both a hero video and a separate
// voice-note player) - starting one that isn't muted pauses every other
// unmuted media element already playing. A muted element (an ambient looping
// hero, say) is left alone, since it can't be heard over anything else.
// 'play' doesn't bubble, so capture phase is required to observe it here
// instead of on each element individually - this also means any future
// audible element added to the page is covered automatically.
export function useSingleAudibleMedia() {
  useEffect(() => {
    const handlePlay = (e) => {
      document.querySelectorAll('video, audio').forEach((el) => {
        if (el !== e.target && !el.muted) el.pause();
      });
    };

    document.addEventListener('play', handlePlay, true);
    return () => document.removeEventListener('play', handlePlay, true);
  }, []);
}
